  
export default {
  primary: "#ff2d2d",
  inverse: "#fff",
  // colors
  darkGrey: "#333447",
  black: "#000",

  // pixel-art UI chrome
  pixelFont: "'Silkscreen', 'GT-Walsheim-Pro-Bold', monospace",
  pixelBorder: "3px",
  pixelShadow: "4px 4px 0",
  pixelShadowSmall: "2px 2px 0",
  shadowColor: "#333447",

  // grid
  width: "96%",
  wrapperWidth: "65rem",
  gutter: "4%",
  breakpointPhone: "850px",
  breakpointTablet: "1024px",
  breakpointLaptop: "1200px",
  breakpointLarge: "60em" // 960px
}